// src/components/layout/MainLayout.tsx
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from '../Header/Header';
import { Sidebar } from '../Sidebar/Sidebar';
import './MainLayout.scss';

const MainLayout: React.FC = () => {
  const location = useLocation();

  return (
    <div className="main-layout">
      <Header />
      <Sidebar />
      <main className="main-content">
        {/* Keyed by pathname so React remounts this div on every navigation,
            re-triggering the fadeInUp animation each time (rather than
            playing once and never again, since MainLayout itself doesn't
            unmount between routes). */}
        <div className="content-area page-transition" key={location.pathname}>
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default MainLayout;